class AnnotationHelper {
    constructor(canvas, img, clearButton, widthInput) {
        this.drawColor = '#000000';  // Black color for draw line
        this.blurColor = '#FFFFFF';  // White color for blur line
        this.canvas = canvas;
        this.img = img;
        this.ctx = this.canvas.getContext('2d');
        this.clearAnnotationButton = clearButton;
        this.canvas.width = this.img.width;
        this.canvas.height = this.img.height;
        this.ctx.lineWidth = widthInput;
        this.originalImageData = this.ctx.getImageData(0, 0, this.canvas.width, this.canvas.height);

        // default mode is 'draw'
        this.drawingMode = 'draw';
        this.setDrawingMode(this.drawingMode);

        this.drawModeMap = new Map();
        this.blurModeMap = new Map();

        this.startX = 0;
        this.startY = 0;
        this.isDrawing = false;
    }

    setDrawingMode(mode) {
        this.drawingMode = mode;

        // this.ctx.beginPath();

        // Set properties for each mode directly here
        if (mode === 'draw') {
            this.ctx.strokeStyle = this.drawColor;
            this.ctx.globalAlpha = 1;
        } else if (mode === 'blur') {
            this.ctx.strokeStyle = this.blurColor;
            this.ctx.globalAlpha = 0.02;
        }
    }

    getDrawingMode() {
        return this.drawingMode;
    }

    getDrawnArea() {
        return {
            drawModeArea: Array.from(this.drawModeMap.values()),
            blurModeArea: Array.from(this.blurModeMap.values())
        };
    }

    getCanvasSize() {
        return {
            width: this.canvas.width,
            height: this.canvas.height
        };
    }

    enableAnnotation() {
        let painting = false;

        const startPosition = (e) => {
            painting = true;
            draw(e);
        };

        const finishedPosition = () => {
            painting = false;
            this.ctx.beginPath(); // Reset path when drawing ends
            this.isDrawing = false;
        };

        const clearCanvas = () => {
            this.ctx.clearRect(0, 0, this.canvas.width, this.canvas.height);
            this.ctx.putImageData(this.originalImageData, 0, 0);
            this.drawModeMap.clear();
            this.blurModeMap.clear();
        };

        const draw = (e) => {
            if (!painting) return;

            e.preventDefault();
            const coords = getCoords(e);

            // Log once at the start of each draw operation
            if (!this.isDrawing) {
                console.log("Drawing mode: ", this.drawingMode);
                this.isDrawing = true;
            }

            this.ctx.lineCap = 'round';

            // Use the strokeStyle set in setDrawingMode without changing it here
            this.ctx.lineTo(coords.x, coords.y);
            this.ctx.stroke();

            this.ctx.beginPath();
            this.ctx.moveTo(coords.x, coords.y);

            // Calculate surrounding pixels for storing in map
            const radius = Math.floor(this.ctx.lineWidth / 2);
            for (let dx = -radius; dx <= radius; dx++) {
                for (let dy = -radius; dy <= radius; dy++) {
                    const distance = Math.sqrt(dx * dx + dy * dy);
                    if (distance <= radius) {
                        const x = coords.x + dx;
                        const y = coords.y + dy;
                        if (x >= 0 && x < this.canvas.width && y >= 0 && y < this.canvas.height) {
                            const key = `${x},${y}`;
                            const coordinate = { x, y };
                            if (this.drawingMode === 'draw') {
                                if (!this.drawModeMap.has(key)) {
                                    this.drawModeMap.set(key, coordinate);
                                }
                            } else if (this.drawingMode === 'blur') {
                                if (!this.blurModeMap.has(key)) {
                                    this.blurModeMap.set(key, coordinate);
                                }
                            }
                        }
                    }
                }
            }
        };

        const getCoords = (e) => {
            if (e.touches) {
                e = e.touches[0];
            }
            return {
                x: e.layerX - this.canvas.offsetLeft,
                y: e.layerY - this.canvas.offsetTop
            };
        };

        this.canvas.addEventListener('mousedown', startPosition.bind(this));
        this.canvas.addEventListener('mouseup', () => finishedPosition());
        this.canvas.addEventListener('mousemove', draw.bind(this));
        this.canvas.addEventListener('touchstart', startPosition.bind(this));
        this.canvas.addEventListener('touchend', () => finishedPosition());
        this.canvas.addEventListener('touchmove', draw.bind(this));

        this.clearAnnotationButton.onclick = clearCanvas.bind(this);
    }
}

export default AnnotationHelper;
